import { Place } from './models/place.model';
import { AdminNotification } from './models/adminNotification.model';
import { AdminNotificationData } from './models/adminNotificationData.model';
import { AdminDashboard } from './models/adminDashboard.model';
import { City } from './models/city.model';
import { ImageStore } from './models/imagestore.model';
import { SubCategory } from './models/subcategory.model';
import { Post } from './models/post.model';
import { Buyer } from './models/buyer.model';
import { Category } from './models/category.model';
import { AlertService } from './alert.service';
import { ToastrService } from 'ngx-toastr';
import { AppComponent } from './app.component';
import { Injectable } from '@angular/core';

import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { HttpClient } from '@angular/common/http';
import 'rxjs/add/operator/finally';
import 'rxjs/add/observable/throw';
import {Observable} from 'rxjs/Rx';
import { User } from './models/user.model';
import { Product } from './models/product.model';
import { ProductOrder } from './models/ProductOrder.model';
import { Review } from './models/review.model';

@Injectable()
export class UserServiceService {

  constructor(public http: HttpClient,  private alertService : AlertService) {
   }

   login(user:User) : Observable<User>{
    return this.http.post<User>(AppComponent.API_ENDPOINT+'admin_login.php',user)
    .catch((e: any) => Observable.throw(this.loginErrorHandler(e)))
    .finally(()=>{
    });
  }

  get(url:any) : Observable<any>{
    return this.http.get<any>(AppComponent.API_ENDPOINT+url)
    .catch((e: any) => Observable.throw(this.dashboardErrorHandler(e)))
    .finally(()=>{
    });
  }

  post(url:string, data : any) : Observable<any>{
    return this.http.post<any>(AppComponent.API_ENDPOINT+url, data)
    .catch((e: any) => Observable.throw(this.errorHandler(e)))
    .finally(()=>{
    });
  }

  getDashboard() : Observable<AdminDashboard>{
    return this.http.get<AdminDashboard>(AppComponent.API_ENDPOINT+'dashboard')
    .catch((e: any) => Observable.throw(this.dashboardErrorHandler(e)))
    .finally(()=>{
    });
  }

  getBuyers() : Observable<Buyer[]>{
    return this.http.get<Buyer[]>(AppComponent.API_ENDPOINT+'buyers')
    .catch((e: any) => Observable.throw(this.errorHandler(e)))
    .finally(()=>{
    });
  }

  updateBuyer(buyer : Buyer) : Observable<Buyer>{
    return this.http.post<Buyer>(AppComponent.API_ENDPOINT+'buyers',buyer)
    .catch((e: any) => Observable.throw(this.errorHandler(e)))
    .finally(()=>{
    });
  }

  getPosts() : Observable<Post[]>{
    return this.http.get<Post[]>(AppComponent.API_ENDPOINT+'posts')
    .catch((e: any) => Observable.throw(this.errorHandler(e)))
    .finally(()=>{
    });
  }

  updatePost(post: Post) : Observable<Post>{
    return this.http.post<Post>(AppComponent.API_ENDPOINT+'posts',post)
    .catch((e: any) => Observable.throw(this.errorHandler(e)))
    .finally(()=>{
    });
  }

  getSubCategories() : Observable<SubCategory[]>{
    return this.http.get<SubCategory[]>(AppComponent.API_ENDPOINT+'subCategories')
    .catch((e: any) => Observable.throw(this.errorHandler(e)))
    .finally(()=>{
    });
  }


  saveCategory(category : Category) : Observable<Category>{
    return this.http.post<Category>(AppComponent.API_ENDPOINT+'admin/create-category',category)
    .catch((e: any) => Observable.throw(this.errorHandler(e)))
    .finally(()=>{
    });
  }

  deleteCategory(category : Category) : Observable<Category>{
    return this.http.post<Category>(AppComponent.API_ENDPOINT+'admin/delete-category',category)
    .catch((e: any) => Observable.throw(this.errorHandler(e)))
    .finally(()=>{
    });
  }

  getCategories() : Observable<Category[]>{
    return this.http.get<Category[]>(AppComponent.API_ENDPOINT+'categories')
    .catch((e: any) => Observable.throw(this.errorHandler(e)))
    .finally(()=>{
    });
  }
  

  getCities() : Observable<City[]>{
    return this.http.get<City[]>(AppComponent.API_ENDPOINT+'cities')
    .catch((e: any) => Observable.throw(this.errorHandler(e)))
    .finally(()=>{
    });
  }

  saveCity(city : City) : Observable<City>{
    return this.http.post<City>(AppComponent.API_ENDPOINT+'admin/create-city',city)
    .catch((e: any) => Observable.throw(this.errorHandler(e)))
    .finally(()=>{
    });
  }

  deleteCity(city : City) : Observable<City>{
    return this.http.post<City>(AppComponent.API_ENDPOINT+'admin/delete-city',city)
    .catch((e: any) => Observable.throw(this.errorHandler(e)))
    .finally(()=>{
    });
  }


  savePlace(place : Place) : Observable<Place>{
    return this.http.post<Place>(AppComponent.API_ENDPOINT+'admin/create-place',place)
    .catch((e: any) => Observable.throw(this.errorHandler(e)))
    .finally(()=>{
    });
  }

  deletePlace(place : Place) : Observable<Place>{
    return this.http.post<Place>(AppComponent.API_ENDPOINT+'admin/delete-place',place)
    .catch((e: any) => Observable.throw(this.errorHandler(e)))
    .finally(()=>{
    });
  }

  getPlaces() : Observable<Place[]>{
    return this.http.get<Place[]>(AppComponent.API_ENDPOINT+'places')
    .catch((e: any) => Observable.throw(this.errorHandler(e)))
    .finally(()=>{
    });
  }

  saveReview(review : Review) : Observable<Review>{
    return this.http.post<Review>(AppComponent.API_ENDPOINT+'admin/create-review',review)
    .catch((e: any) => Observable.throw(this.errorHandler(e)))
    .finally(()=>{
    });
  }

  getReviews() : Observable<Review[]>{
    return this.http.get<Review[]>(AppComponent.API_ENDPOINT+'admin/reviews')
    .catch((e: any) => Observable.throw(this.errorHandler(e)))
    .finally(()=>{
    });
  }


  getImageStores() : Observable<ImageStore[]>{
    return this.http.get<ImageStore[]>(AppComponent.API_ENDPOINT+'admin/imagestores')
    .catch((e: any) => Observable.throw(this.errorHandler(e)))
    .finally(()=>{
    });
  }

  saveImageStore(imageStore : ImageStore) : Observable<ImageStore>{
    return this.http.post<ImageStore>(AppComponent.API_ENDPOINT+'admin/create-imagestore',imageStore)
    .catch((e: any) => Observable.throw(this.errorHandler(e)))
    .finally(()=>{
    });
  }

  uploadImage(imageStore : ImageStore) : Observable<ImageStore>{
    return this.http.post<ImageStore>(AppComponent.API_ENDPOINT+'admin/upload-image',imageStore)
    .catch((e: any) => Observable.throw(this.errorHandler(e)))
    .finally(()=>{
    });
  }


  deleteImage(id : number) : Observable<ImageStore>{
    return this.http.get<ImageStore>(AppComponent.API_ENDPOINT+'image/delete/'+id)
    .catch((e: any) => Observable.throw(this.errorHandler(e)))
    .finally(()=>{
    });
  }

  saveProduct(product : Product) : Observable<Product>{
    return this.http.post<Product>(AppComponent.API_ENDPOINT+'products',product)
    .catch((e: any) => Observable.throw(this.errorHandler(e)))
    .finally(()=>{
    });
  }

  getProducts() : Observable<Product[]>{
    return this.http.get<Product[]>(AppComponent.API_ENDPOINT+'products')
    .catch((e: any) => Observable.throw(this.errorHandler(e)))
    .finally(()=>{
    });
  }


  saveProductOrder(productOrders : ProductOrder[]) : Observable<ProductOrder>{
    return this.http.post<ProductOrder>(AppComponent.API_ENDPOINT+'product-order',productOrders)
    .catch((e: any) => Observable.throw(this.errorHandler(e)))
    .finally(()=>{
    });
  }

  getProductOrder() : Observable<ProductOrder[]>{
    return this.http.get<ProductOrder[]>(AppComponent.API_ENDPOINT+'product-order')
    .catch((e: any) => Observable.throw(this.errorHandler(e)))
    .finally(()=>{
    });
  }

  getProductDistinct() : Observable<ProductOrder[]>{
    return this.http.get<ProductOrder[]>(AppComponent.API_ENDPOINT+'product-order/distinct')
    .catch((e: any) => Observable.throw(this.errorHandler(e)))
    .finally(()=>{
    });
  }


  getProductByUuid(uuid : string) : Observable<ProductOrder[]>{
    return this.http.get<ProductOrder[]>(AppComponent.API_ENDPOINT+'product-order/uuid/'+uuid)
    .catch((e: any) => Observable.throw(this.errorHandler(e)))
    .finally(()=>{
    });
  }

  displayPDF(uuid : string) {
    return this.http.get(AppComponent.API_ENDPOINT+'opens/product-order-print/'+uuid)
    .catch((e: any) => Observable.throw(this.errorHandler(e)))
    .finally(()=>{
    });
  }

  getAdminNotificationData() : Observable<AdminNotificationData>{
    return this.http.get<AdminNotificationData>(AppComponent.API_ENDPOINT+'notification-data')
    .catch((e: any) => Observable.throw(this.errorHandler(e)))
    .finally(()=>{
    });
  }


  saveAdminNotificationData(adminNotification : AdminNotification) : Observable<AdminNotification>{
    return this.http.post<AdminNotification>(AppComponent.API_ENDPOINT+'send-notification',adminNotification)
    .catch((e: any) => Observable.throw(this.errorHandler(e)))
    .finally(()=>{
    });
  }

  test() : Observable<string[]>{
    return this.http.get<string[]>(AppComponent.API_ENDPOINT+'opens/states')
    .catch((e: any) => Observable.throw(this.errorHandler(e)))
    .finally(()=>{
    });
  }


  errorHandler(error: any): void {
    console.log(error);
    this.alertService.showAlert("Something went wrong",4);
  }

  dashboardErrorHandler(error: any): void {
    console.log(error);
    //this.alertService.showAlert("Dashboard is not supported",4);
  }

  loginErrorHandler(error: any): void {
    console.log(error);
    this.alertService.showAlert("Wrong Username and/or password",4);
  }

}



// WEBPACK FOOTER //
// ./src/app/user-service.service.ts